import { useState, useRef, useEffect } from "react";
import { getFileUrl } from "../../utils/GetAuthUser";

const fileUrl = getFileUrl();

const ArtistSelect = ({ artists, value, onChange, placeholder }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  var selectedArtist = artists.find((a) => a.id === value) ;

  selectedArtist = selectedArtist || null; // Ensure it's null if not found

  // console.log("Selected Artist:", selectedArtist);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      {/* Input Styled Box */}
      <div
        onClick={() => setOpen(!open)}
        className="w-full px-3 mb-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary cursor-pointer"
      >
        {selectedArtist !== null ? (
          <div className="flex items-center gap-3">
            <img
            src={`${fileUrl}/${selectedArtist.artistImage}`}
              
              alt={selectedArtist.artistName}
              className="w-8 h-8 rounded-full"
            />
            <div>
              <div>{selectedArtist.artistName}</div>
              <div
                className={`text-xs ${
                  selectedArtist.available ? "text-green-600" : "text-red-600"
                }`}
              >
                {selectedArtist.available ? "Available" : "Not Available"}
              </div>
            </div>
          </div>
        ) : (
          <span className="text-gray-400">{placeholder}</span>
        )}
      </div>

      {/* Dropdown */}
      {open && (
        <div className="absolute z-50 w-full bg-white border border-border_color rounded-xl shadow-lg max-h-60 overflow-y-auto">
          {artists.map((artist) => (
            <div
              key={artist.id}
              onClick={() => {
                onChange(artist.id);
                setOpen(false);
              }}
              className="flex items-center gap-3 px-3 py-2 hover:bg-gray-100 cursor-pointer"
            >
              <img
                 src={`${fileUrl}/${artist.artistImage}`}
                alt={artist.artistName}
                className="w-8 h-8 rounded-full"
              />
              <div>
                <div>{artist.artistName}</div>
                <div
                  className={`text-xs ${
                    artist.available ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {artist.available ? "Available" : "Not Available"}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ArtistSelect;
